import { SET_FILTERS, RESET_FILTERS, SET_INITIAL_FILTERS } from './types';

export const setFilters = ({ route, ...payload }) => ({
    type: SET_FILTERS,
    payload,
    route,
});

export const resetFilters = ({ route, ...payload }) => ({
    type: RESET_FILTERS,
    payload,
    route,
});

export const setInitialFilters = ({ route, ...payload }) => ({
    type: SET_INITIAL_FILTERS,
    payload,
    route,
});
